<template>
  <div id="modalTransfer" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ type == "edit" ? '$t("transfer.修改")' : '$t("transfer.查看")'
            }}{{ $t("transfer.转运信息") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form v-show="info">
            <div class="form-group row align-items-center mg-b-5">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("transfer.客户信息：") }}</label
              >
              <div class="col-md-6 col-sm-12 form-row tx-gray-900">
                {{ info.distributorName }}
              </div>
            </div>
            <div
              class="form-group row align-items-start mg-b-5"
              v-if="info.address"
            >
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("transfer.收件人信息：") }}</label
              >
              <div class="col-md-6 col-sm-12 tx-gray-900">
                <p class="tx-gray-300 mg-y-5">
                  {{ $t("transfer.地址：") }}
                  <span class="tx-gray-900">
                    {{
                      info.address && jsonParse(info.address).address
                        ? jsonParse(info.address).address
                        : "---"
                    }}
                  </span>
                </p>
                <p class="tx-gray-300 mg-b-5">
                  {{ $t("transfer.城市/州（省）：") }}
                  <span class="tx-gray-900">
                    {{
                      info.address && jsonParse(info.address).city
                        ? jsonParse(info.address).city
                        : "---"
                    }}
                    /
                    {{
                      info.address && jsonParse(info.address).province
                        ? jsonParse(info.address).province
                        : "---"
                    }}
                  </span>
                </p>
                <p class="tx-gray-300 mg-b-5">
                  {{ $t("transfer.邮编：") }}
                  <span class="tx-gray-900">
                    {{
                      info.address && jsonParse(info.address).postCode
                        ? jsonParse(info.address).postCode
                        : "---"
                    }}
                  </span>
                </p>
                <p class="tx-gray-300 mg-b-5">
                  {{ $t("transfer.收件人：") }}
                  <span class="tx-gray-900">
                    {{
                      info.address && jsonParse(info.address).contact
                        ? jsonParse(info.address).contact
                        : "---"
                    }}
                  </span>
                </p>
                <p class="tx-gray-300 mg-b-0">
                  {{ $t("transfer.手机/电话：") }}
                  <span class="tx-gray-900">
                    {{
                      info.address && jsonParse(info.address).mobile
                        ? jsonParse(info.address).mobile
                        : "---"
                    }}
                    /
                    {{
                      info.address && jsonParse(info.address).telephone
                        ? jsonParse(info.address).telephone
                        : "---"
                    }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group row align-items-center mg-b-5">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("transfer.选择物流：") }}</label
              >
              <div class="col-md-6 col-sm-12 form-row tx-gray-900">
                {{ info.logistics }}
              </div>
            </div>
            <div class="form-group row align-items-center mg-b-5">
              <label
                for="iptContact"
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("transfer.转运：") }}</label
              >
              <div class="col-md-6 col-sm-12 form-row tx-gray-900">
                {{ $t("transfer.中国") }} --- {{ info.countryName }}
              </div>
            </div>
            <div v-show="type == 'edit'">
              <div class="form-group row align-items-center mg-b-10">
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.申报价值(￥)：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <input
                    v-model="item.declareFee"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.申报内容：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <input
                    v-model="item.declareRemark"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="form-group row align-items-center mg-b-10">
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.物流单号：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <input
                    v-model="item.transTrackNumber"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.实际物流渠道：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <input
                    v-model="item.realLogistics"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.实收运费(￥)：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <input
                    v-model="item.shippingFee"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <label
                  for="iptContact"
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("transfer.合作物流渠道：") }}</label
                >
                <div class="col-md-3 col-sm-12 form-row tx-gray-900">
                  <select class="form-control pd-y-0" v-model="platform">
                    <option value="">
                      {{ $t("transfer.请选择合作物流渠道") }}
                    </option>
                    <option
                      v-for="status in trackPartners"
                      :key="status.key"
                      :value="status.key"
                    >
                      {{ status.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="table-wrap mg-y-15">
              <table class="table table-striped mg-b-0">
                <thead>
                  <tr>
                    <th>{{ $t("transfer.包裹物品备注") }}</th>
                    <th>{{ $t("transfer.内部ID") }}</th>
                    <th>{{ $t("transfer.仓库") }}</th>
                    <th>{{ $t("transfer.货架号") }}</th>
                    <th>{{ $t("transfer.体积重(cm)/包裹重(g)") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in trackItems"
                    :key="item.id"
                    :value="item.id"
                  >
                    <td class="valign-middle">
                      <span class="tx-gray-900">{{ item.packageRemark }}</span>
                    </td>
                    <td class="valign-middle">
                      <span class="tx-gray-900">{{ item.id }}</span>
                    </td>
                    <td class="valign-middle">
                      <span class="tx-gray-900">{{ item.addressName }}</span>
                    </td>
                    <td class="valign-middle">
                      <span class="tx-gray-900">{{
                        item.shelfCode || "---"
                      }}</span>
                    </td>
                    <td class="valign-middle">
                      <p class="mg-b-5">
                        <span>{{ $t("transfer.体积重：") }}</span>
                        <span class="tx-gray-900"
                          >{{ item.long }}*{{ item.width }}*{{
                            item.height
                          }}</span
                        >
                      </p>
                      <p class="mg-b-0">
                        <span>{{ $t("transfer.包裹重：") }}</span>
                        <span class="tx-gray-900">{{ item.weight }}</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!trackItems || trackItems.length < 1">
                  <tr>
                    <td colspan="8">
                      <div class="col-12 none-product">
                        <i class="fa fa-ban"></i
                        >{{ $t("transfer.没有打包转运的包裹") }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group row align-items-center mg-b-0">
              <label
                for="iptContact"
                class="
                  col-md-6 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
              ></label>
              <div class="col-md-6 col-sm-12 tx-gray-900 tx-right">
                <span>{{ $t("transfer.包裹数：") }} {{ info.cnt }}</span>
                <span class="mg-l-20"
                  >{{ $t("transfer.订单重量：") }}
                  {{ info.packageWeight }}g</span
                >
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            v-show="type == 'edit'"
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save()"
          >
            {{ $t("transfer.确定") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("transfer.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "open", "type"],
  data() {
    return {
      item: "",
      loading: false,
      trackItems: [],
      logistics: "",
      platform: "",
      trackPartners: [],
    };
  },
  watch: {
    open() {
      this.item = JSON.parse(JSON.stringify(this.info));
      this.logistics = this.item.realLogistics
        ? this.item.realLogistics
        : this.item.logistics;
      this.platform = this.item.platform ? this.item.platform : "";
      this.getTrack();
    },
  },
  filters: {},
  methods: {
    getTrack() {
      this.trackItems = [];
      $.api_call(
        "api.DistributorPackage.getTransportPackageDetail",
        {
          id: this.item.id,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.trackItems = r.Data.Results.packages;
            this.trackPartners = r.Data.Results.trackPartners;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    jsonParse(val) {
      if (!val) return;
      return JSON.parse(val);
    },
    save() {
      this.loading = true;
      let param = {
        id: this.item.id,
        declareFee: this.item.declareFee,
        declareRemark: this.item.declareRemark,
        realLogistics: this.item.realLogistics,
        transTrackNumber: this.item.transTrackNumber,
        shippingFee: this.item.shippingFee,
        platform: this.platform,
      };
      $.api_call(
        "api.DistributorPackage.changeTransportPackageByUser",
        param,
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.修改转运包裹成功"), "success");
            $("#modalTransfer").modal("hide");
            this.$parent.updateSuccess(this.item.id);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>
